// extracted by mini-css-extract-plugin
export default {"about":"About_about__yUZyc","about__title":"About_about__title__Q+vi6","about__text":"About_about__text__fXzhM","author":"About_author__X7mlB"};